<template>
  <div class="app" :class="{ 'layout-hidden': isLayoutHidden }" data-app>
    <AppHeader v-if="!isLayoutHidden" fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand eb-navbar-brand" to="/home">
        <span class="navbar-brand-full">{{ companyName }}</span>
        <span class="navbar-brand-minimized">{{ companyAlpa }}</span>
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <b-navbar-nav class="d-md-down-none">
        <b-nav-item class="px-3">
          <div class="app-search"></div>
        </b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto hide">
        <notificationbell></notificationbell>
      </b-navbar-nav>
      <b-navbar-nav>
        <DefaultHeaderDropdownAccnt />
      </b-navbar-nav>
    </AppHeader>
    <div class="app-body" v-if="$currentUserData || isLayoutHidden">
      <template v-if="!isLayoutHidden">
        <AppSidebar fixed>
          <SidebarHeader />
          <SidebarForm />
          <SidebarNav :navItems="items"></SidebarNav>
          <SidebarFooter />
          <SidebarMinimizer />
        </AppSidebar>
        <main class="main">
          <Breadcrumb :list="list" />
          <div class="container-fluid">
            <router-view></router-view>
          </div>
        </main>
        <AppAside fixed>
          <!--aside-->
          <DefaultAside />
        </AppAside>
      </template>
      <template v-else>
        <main class="main p-0">
          <router-view></router-view>
        </main>
      </template>
    </div>
    <TheFooter v-if="!isLayoutHidden">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-6">
            2018 - {{ new Date().getFullYear() }} ©
            <a href="https://trigital.in/">Trigital Technologies Pvt Ltd</a>
          </div>
          <div class="col-md-6">
            <div class="text-md-right footer-links d-none d-md-block">
              <a href="https://nipige.com/" class="mr-2">Website</a>
              <a href="https://nipige.com/about-us-leading-e-commerce-saas-platform/" class="mr-2">About</a>
              <a href="mailto:contactus@nipige.com" class="mr-2">Support</a>
              <a href="https://trigital.in/contact-us/" class="mr-2">Contact Us</a>
            </div>
          </div>
        </div>
      </div>
    </TheFooter>
    <orderModal v-if="!isLayoutHidden && isShowModal"></orderModal>
  </div>
</template>

<script>
import nav from "@/_nav";
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  AsideToggler,
  Footer as TheFooter,
  Breadcrumb,
} from "@/components";
import orderModal from "@/components/OrderModal/OrderModal.vue";
import DefaultAside from "@/containers/DefaultAside";
import DefaultHeaderDropdownAccnt from "@/containers/DefaultHeaderDropdownAccnt";
import { mapActions, mapGetters } from "vuex";
import notificationbell from "@/components/Header/headerbell.vue";
export default {
  name: "DefaultContainer",
  components: {
    orderModal,
    notificationbell,
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
  },
  data() {
    return {
      nav: nav.items,
      search: "",
      newMessageData: null,
      modalShow: false,
      companyAlpa: "N",
      companyName: "NIPIGE",
    };
  },
  computed: {
    ...mapGetters({
      businessPlanListById: "businessPlan/GetBusinessPlanListById",
    }),
    isLayoutHidden() {
      return this.$route.matched.some((r) => r.meta && r.meta.hideLayout);
    },
    userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
      }
    },
    currentOrderData() {
      return this.$store.getters["notification/GetCurrentOrderDetails"];
    },
    isShowModal() {
      return this.$store.getters["notification/GetNotificationModalState"];
    },
    searchText: {
      get: function () {
        return this.search;
      },
      set: function (newVal) {
        this.$store.dispatch("product/search", newVal);
        this.search = newVal;
      },
    },
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter((route) => route.name || route.meta.label);
    },
    isNavReady() {
      if (!this.$currentUserData) return false;
      return true;
    },
    selectedBusinessPlan() {
      const businessPlanId = this.$currentUserData?.agreement?.business_plan?._id;
      if (!businessPlanId) return null;
      if (this.businessPlanListById?._id === businessPlanId) {
        return this.businessPlanListById;
      }
      return null;
    },
    items() {
      if (!this.isNavReady) return [];

      const navCopy = this.deepCloneNav(this.nav);
      const applyAdminFilter = (navItems) => {
        return this.isAdminUser() ? this.filterNavForAdmin(navItems) : navItems;
      };

      if (this.selectedBusinessPlan) {
        const businessPlan = this.selectedBusinessPlan;
        if (businessPlan?.features?.length) {
          const namesData = this.getParsedNamesFromBusinessPlan(businessPlan);
          return applyAdminFilter(
            this.filterNavByBusinessPlan(navCopy, namesData)
          );
        }
      }

      const permissionsData = this.getParsedPermissions();
      return applyAdminFilter(
        this.filterNavByPermissions(navCopy, permissionsData)
      );
    },
  },
  methods: {
    ...mapActions({
      getPreference: "tenant/getTenantPreferences",
      fetchBusinessPlanListById: "businessPlan/businessPlanListByIdAction",
    }),
    isAdminUser() {
      return this.userRole === "Admin" || this.$currentUserData?.role === "Admin";
    },
    filterNavForAdmin(navItems) {
      return (navItems || []).filter((item) => item.showForAdmin === true);
    },
    deepCloneNav(items) {
      return (items || []).map((item) => ({
        ...item,
        children: item.children
          ? this.deepCloneNav(item.children)
          : undefined,
      }));
    },
    filterNavByBusinessPlan(navItems, namesData) {
      const filterNavTree = (navItem) => {
        if (!navItem.auth) return navItem;
        const filteredChildren = navItem.children
          ? navItem.children
              .map((x) => filterNavTree(x))
              .filter((x) => x !== null)
          : undefined;
        if (filteredChildren && filteredChildren.length > 0) {
          navItem.children = filteredChildren;
          return navItem;
        }
        if (navItem.name && namesData.hasName([navItem.name])) {
          navItem.children = filteredChildren;
          return navItem;
        }
        return null;
      };
      return navItems.map((x) => filterNavTree(x)).filter((x) => x !== null);
    },
    filterNavByPermissions(navItems, permissionsData) {
      const filterNavTree = (navItem) => {
        if (!navItem.auth) return navItem;
        if (
          navItem.auth.required &&
          Array.isArray(navItem.auth.required) &&
          permissionsData.hasPermission(navItem.auth.required)
        ) {
          if (navItem.children) {
            navItem.children = navItem.children
              .map((x) => filterNavTree(x))
              .filter((x) => x !== null);
          }
          return navItem;
        }
        if (
          navItem.auth.oneOf &&
          Array.isArray(navItem.auth.oneOf) &&
          permissionsData.hasPermission(navItem.auth.oneOf)
        ) {
          if (navItem.children) {
            navItem.children = navItem.children
              .map((x) => filterNavTree(x))
              .filter((x) => x !== null);
          }
          return navItem;
        }
        return null;
      };
      return navItems.map((x) => filterNavTree(x)).filter((x) => x !== null);
    },
    getParsedPermissions() {
      const permissions = { ...this.$currentUserData.permissions };
      permissions.hasPermission = function (permissions) {
        if (!Array.isArray(permissions)) {
          permissions = [permissions];
        }
        for (const p of permissions) {
          if (this[p]) {
            return true;
          }
        }
        return false;
      };
      return permissions;
    },
    getParsedNamesFromBusinessPlan(businessPlan) {
      const nameSet = new Set();
      const normalizeName = (value) => {
        if (!value || typeof value !== "string") return "";
        return value
          .toLowerCase()
          .replace(/&/g, " and ")
          .replace(/mangement/g, "management")
          .replace(/\s+/g, " ")
          .trim()
          .replace(/\bresources\b/g, "resource")
          .replace(/\bfeatures\b/g, "feature")
          .replace(/\badvertisements\b/g, "advertisement")
          .replace(/\s+/g, "");
      };
      (businessPlan.features || []).forEach((feature) => {
        if (feature?.name) {
          const normalizedName = normalizeName(feature.name);
          if (normalizedName) {
            nameSet.add(normalizedName);
          }
        }
      });
      return {
        hasName(names) {
          if (!Array.isArray(names)) {
            names = [names];
          }
          for (const name of names) {
            if (name && nameSet.has(normalizeName(name))) {
              return true;
            }
          }
          return false;
        },
      };
    },
    socketReconnect() {
      if (this.$currentUserData) {
        let userdata = this.$currentUserData;
        let object = {
          uid: userdata._id,
        };
        // $socket is socket.io-client instance
        this.$socket.emit("adduser", object);
        this.$socket.emit("getunread", object);
      }
      this.sockets.subscribe("mymessage", (data) => {
        if (Array.isArray(data)) {
          this.$store.dispatch("notification/setAllNotifications", data);
        } else {
          if (
            data.message.type === "order-request" ||
            data.message.type === "manufacturer-order-request"
          ) {
            this.$store.dispatch("notification/openNotificationModal", true);
            this.$store.dispatch("notification/setNewOrdersNotification", data);
            let orderLink = this.$store.getters["notification/GetNewOrderNotification"];
            this.$store.dispatch(
              "notification/getOrderDetails",
              orderLink["message"]["orderDetailsLink"]
            );
          }
        }
      });
    },
  },
  mounted() {
    const businessPlanId = this.$currentUserData?.agreement?.business_plan?._id;
    if (businessPlanId) {
      this.fetchBusinessPlanListById({ id: businessPlanId });
    }
    if (this.$currentUserData) {
      this.initSocket();
      let userdata = this.$currentUserData;
      let object = {
        uid: userdata._id,
      };
      if (this.userRole === "Partner") {
        this.getPreference(userdata.tenant);
      } else if (this.userRole === "Tenant") {
        this.getPreference(userdata._id);
      }
      // $socket is socket.io-client instance
      this.$socket.emit("adduser", object);
      this.$socket.emit("getunread", object);
      if (this.sockets) {
        this.sockets.subscribe("mymessage", (data) => {
          if (Array.isArray(data)) {
            this.$store.dispatch("notification/setAllNotifications", data);
          } else {
            if (
              data.message.type === "order-request" ||
              data.message.type === "manufacturer-order-request"
            ) {
              this.$store.dispatch("notification/openNotificationModal", true);
              this.$store.dispatch("notification/setNewOrdersNotification", data);
              let orderLink = this.$store.getters["notification/GetNewOrderNotification"];
              this.$store.dispatch(
                "notification/getOrderDetails",
                orderLink["message"]["orderDetailsLink"]
              );
            }
          }
        });
      }
    }
    const name = JSON.parse(sessionStorage.getItem("companyName"));
    this.companyName = name || "NIPIGE";
    this.companyAlpa = name?.toUpperCase()?.slice(0, 1) || "N";
  },
  sockets: {
    connect: function () {},
    reconnect: function () {
      this.$socket.io.reconnect();
      this.socketReconnect();
    },
    disconnect: () => {},
  },
};
</script>

<style>
.eb-navbar {
  background: linear-gradient(135deg, #8b76de 0, #8178e7 60%);
  width: 200px;
  margin-left: -17px;
  height: 71px;
  margin-top: -15px;
}

.eb-navbar-brand {
  margin-left: -14px !important;
  margin-top: -7px !important;
}

@media (min-width: 992px) {
  .brand-minimized .app-header .navbar-brand {
    width: 50px !important;
    background-color: transparent;
    transition: 0.2s;
    transition-timing-function: linear;
  }
}

@media screen and (max-width: 992px) {
  .eb-navbar-brand {
    display: none !important;
  }
}

@media only screen and (max-width: 992px) {
  .app-search {
    display: block !important;
  }
}

@media (max-width: 575.98px) {
  .sidebar-show .main::before,
  .aside-menu-show .main::before {
    background: none !important;
  }
}

@media (min-width: 575.98px) {
  .header-fixed .app-header {
    position: fixed;
  }
}

@media (min-width: 200.98px) {
  .header-fixed .app-header {
    position: fixed;
  }
}

.layout-hidden .main {
  margin-left: 0 !important;
  padding: 0 !important;
}

.layout-hidden .app-body {
  margin-top: 0 !important;
  padding-top: 0 !important;
}
.hide{
  visibility: hidden !important;
}
</style>
